import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { animated, useSpring } from 'react-spring';
import PropTypes from 'prop-types';

const NavbarBottomItem = ({ text, faIcon, isActive }) => {
  const { xy, clipPath1 } = useSpring({
    clipPath1: isActive
      ? 'polygon(5px -20px, 42px -20px, 41px -1px, 6px -8px)'
      : 'polygon(5px -20px, 42px -20px, 42px 33px, 5px 20px)',
    xy: !isActive ? [0, 10] : [0, -10]
  });

  const { xy2, clipPath2, size } = useSpring({
    xy2: !isActive ? [0, 0] : [0, -15],
    clipPath2: isActive
      ? 'polygon(-2px -2px, 73px 11px, 73px 32px, -1px 23px)'
      : 'polygon(-2px -20px, 42px -20px, 41px 8px, 0px 0px)',
    size: isActive ? 1 : 0
  });

  return (
    <div style={{ padding: 10, cursor: 'pointer' }}>
      <animated.div
        style={{
          transform: xy.to((x, y) => `translate(${x}px, ${y}px)`)
        }}
      >
        <animated.div
          style={{
            clipPath: clipPath1
          }}
        >
          <FontAwesomeIcon icon={faIcon} size="lg" />
        </animated.div>
      </animated.div>
      <animated.div
        style={{
          transform: xy2.to((x, y) => `translate(${x}px, ${y}px)`)
        }}
      >
        <animated.div
          style={{
            clipPath: clipPath2
          }}
        >
          <span
            className="text-primary"
            style={{ fontSize: 12, fontWeight: 'bold' }}
          >
            {text}
          </span>
        </animated.div>
      </animated.div>
      <animated.div
        style={{
          height: 5,
          width: 5,
          borderRadius: '50%',
          backgroundColor: 'var(--falcon-primary)',
          margin: 'auto',
          transform: size.to(size => `translateY(-10px) scale(${size})`)
        }}
      />
    </div>
  );
};

NavbarBottomItem.propTypes = {
  faIcon: PropTypes.object.isRequired,
  text: PropTypes.string,
  isActive: PropTypes.bool.isRequired
};

export default NavbarBottomItem;
